import { auth } from "@/utils/firebase";
import { type User, onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { type ReactNode, useEffect, useState } from "react";
import { AuthContext } from "./use-auth";

interface AuthProviderProps {
	children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
	const [user, setUser] = useState<User | null>(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, (user) => {
			setUser(user);
			setLoading(false);
		});
		return () => unsubscribe();
	}, []);

	const login = (email: string, pass: string) => {
		return signInWithEmailAndPassword(auth, email, pass);
	};

	const logout = () => {
		return signOut(auth);
	};

	const value = {
		user,
		loading,
		login,
		logout,
	};

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
